export default __webpack_public_path__ + "static/media/Bb-1.7e23c472.mp3";